import React, {Component, Fragment} from 'react';
import PriceListingRow from "../PriceListingRow";
import HintWrapper from "../HintWrapper";
import {delve} from "../../util/util";

class SummaryTotalListing extends Component {

    render() {

        const {cartSummary, lineThrough} = this.props;


        let billingPeriodDescription = "";

        if (cartSummary.billingPeriodMonths > 0) {
            if (cartSummary.baseArticle.billingPeriodUnlocked) {
                billingPeriodDescription = "Gewählter Abrechnungszeitraum: " + cartSummary.billingPeriodMonths + (cartSummary.billingPeriodMonths > 1 ? " Monate" : " Monat");
            } else {
                billingPeriodDescription = "Abrechnungszeitraum: " + cartSummary.billingPeriodMonths + (cartSummary.billingPeriodMonths > 1 ? " Monate" : " Monat");
            }
        } else {
            billingPeriodDescription = "Einmalige Zahlung"
        }

        let finalSumLabel = "Betrag der 1. Rechnung";

        if (
            delve(cartSummary.cartItems, '0.identifier') === '75000'
            || delve(cartSummary.cartItems, '0.identifier') === '75001'
            || delve(cartSummary.cartItems, '0.identifier') === '75002'
            || delve(cartSummary.cartItems, '0.identifier') === '75003'
        ) {
            finalSumLabel = "Gesamt";
            billingPeriodDescription = 'Einmalige Zahlung';
        }

        return (
            <div className={"summary-step__total"} style={lineThrough?{textDecoration:'line-through'} : null}>
                <div className={"summary-step__total__step"}>
                    <PriceListingRow
                        title={"Gesamt einmalig"}
                        tax={true}
                        price={Number(cartSummary.total.setupFee).toFixed(2) + " €"}
                    />
                    <PriceListingRow
                        title={"Gesamt monatlich"}
                        tax={true}
                        price={Number(cartSummary.total.priceMonthly).toFixed(2) + " €"}
                    />
                </div>
                {cartSummary.domains.length > 0 && cartSummary.billingPeriodMonths !== 12 ? <HintWrapper content={"Der Abrechungszeitraum für bestellte Domains beträgt stets 12 Monate."}
                                                                                                         theme={"blue"}/> : null}
                {cartSummary.total.freeRuntime > 0 ? <PriceListingRow
                    title={"Laufzeitrabatt"}
                    tax={true}
                    caption={cartSummary.total.freeRuntime + (cartSummary.total.freeRuntime === 1 ? " Monat" : " Monate") + " kostenfreie Laufzeit"}
                    promotion={true}
                    price={Number((-1 * cartSummary.total.freeRuntime) * cartSummary.baseArticle.priceMonthly).toFixed(2) + " €"}
                /> : null}

                <PriceListingRow
                    title={finalSumLabel}
                    tax={true}
                    price={Number(cartSummary.firstInvoiceSum).toFixed(2) + " €"}
                    caption={billingPeriodDescription}
                />
            </div>
        );
    }
}

export default SummaryTotalListing;



/** WEBPACK FOOTER **
 ** ./src/components/summary/SummaryTotalListing.js
 **/